// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_tq-5";
export var filledCircle = "_tq-4";
export var historyEntry = "_tq-3";
export var messageSideLeft = "_tq-1";
export var messageSideRight = "_tq-2";
export var orderTrackingCarouselWrapper = "_tq-6";
export var orderTrackingInfoContainer = "_tq-0";